import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import { useKycLogout } from "./use-kyc-logout";

const KycUnderReview = () => {
  const logout = useKycLogout();

  return (
    <div className="mx-auto mt-6 flex w-full max-w-xl grow flex-col justify-center lg:mt-0">
      <div className="flex flex-col items-center text-center">
        <span className="flex size-24 items-center justify-center rounded-full bg-black/5 lg:size-28">
          <Clock className="size-12 text-[#2F2F2F]" />
        </span>
        <h1 className="mt-6 text-2xl font-semibold lg:text-3xl">
          Account under review
        </h1>
        <p className="text-dark-text-300 mt-3 max-w-md text-sm lg:text-base">
          Your identity verification (KYC) has been submitted successfully and
          is currently under review.
        </p>

        <div className="mt-8 w-full rounded-2xl border border-[#CECECE2E] bg-black/[0.03] p-4 text-left">
          <h2 className="font-semibold">What happens next?</h2>
          <p className="text-dark-text-300 mt-1 text-sm">
            We&apos;ll review your information and approve your account once
            it&apos;s complete. This page updates on its own, so you can leave
            it open or come back later.
          </p>
        </div>

        <Button
          variant="outline"
          onClick={logout}
          className="mt-8 h-11 w-full rounded-xl border-[#CECECE2E] bg-transparent hover:bg-black/5"
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default KycUnderReview;
